import DemoReportsTable from './DemoReportsTable'

export default DemoReportsTable
